import CloseIcon from "@mui/icons-material/Close";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import {
  Button,
  DialogActions,
  Paper
} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import StaticTableComponent from "../Master Data Import Export/StaticTableComponent";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const ValidatePopUpForGeographical = ({
  handleCloses,
  open,
  validateDataList,
  onImportValidatedData,
  columnTag,
  validationTableTitle,
}) => {
  const [searchValue, setSearchValue] = React.useState("");

  const handleClose = () => {
    handleCloses();
  };

  const onSearchBox = (searchValue) => {
    setSearchValue(searchValue);
  };

  const getFilteredTableData = (searchData) => {
    if (!searchValue?.trim()) return searchData;

    const searchTerm = searchValue.trim().toLowerCase();

    return searchData.filter((row) => {
      const values = Object.values(row).map((value) => {
        if (value && typeof value === "object" && !Array.isArray(value)) {
          return Object.values(value);
        }
        return value;
      });

      return values.some((value) =>
        value?.toString().toLowerCase().includes(searchTerm)
      );
    });
  };

  const getHeaders = () => {
    switch (columnTag) {
      case 1:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "Region Name", key: "regionName", align: "left" },
          { label: "State Name", key: "stateName", align: "left" },
          { label: "Zone Name", key: "zoneName", align: "left" },
          { label: "District Name", key: "districtName", align: "left" },
          { label: "Taluka Name", key: "talukaName", align: "left" },
          { label: "Area Name", key: "areaName", align: "left" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 2:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "Country Name", key: "countryName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 3:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "Region Name", key: "regionName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Code", key: "code", align: "center" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 4:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "State Name", key: "stateName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 5:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "Zone Name", key: "zoneName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 6:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "District Name", key: "districtName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      case 7:
        return [
          { label: "Sr. No", key: "srNo", align: "center" },
          { label: "Taluka Name", key: "talukaName", align: "left" },
          { label: "Name", key: "name", align: "left" },
          { label: "Short Name", key: "shortName", align: "left" },
          { label: "Sort Order", key: "sortOrder", align: "center" },
          { label: "Error Message", key: "errorMessage", align: "left" },
        ];
      default:
        const baseHeaders = [
          "Sr. No",
          "Name",
          columnTag === 2 ? "Code" : undefined,
          columnTag === 1
            ? "Country Name"
            : columnTag === 2
            ? "Region Name"
            : columnTag === 3
            ? "State Name"
            : columnTag === 4
            ? "Zone Name"
            : columnTag === 5
            ? "District Name"
            : columnTag === 6
            ? "Taluka Name"
            : "",
          "Short Name",
          "Sort Order",
          "Error Message",
        ];
        return baseHeaders.filter((header) => header !== undefined);
    }
  };

  const getTableData = () => {
    return getFilteredTableData(validateDataList).map(
      (validateDataListObj, indexRow) => {
        let sortOrderNo = "";

        console.log(validateDataListObj.flag);
        switch (columnTag) {
          case 1:
            return {
              srNo: indexRow + 1,
              regionName:
                validateDataListObj.region !== null &&
                validateDataListObj.region.name !== null
                  ? validateDataListObj.region.name
                  : "",
              stateName:
                validateDataListObj.state !== null &&
                validateDataListObj.state.name !== null
                  ? validateDataListObj.state.name
                  : "",
              zoneName:
                validateDataListObj.zone !== null &&
                validateDataListObj.zone.name !== null
                  ? validateDataListObj.zone.name
                  : "",
              districtName:
                validateDataListObj.district !== null &&
                validateDataListObj.district.name !== null
                  ? validateDataListObj.district.name
                  : "",
              talukaName:
                validateDataListObj.taluka !== null &&
                validateDataListObj.taluka.name !== null
                  ? validateDataListObj.taluka.name
                  : "",
              areaName:
                validateDataListObj.area !== null &&
                validateDataListObj.area.name !== null
                  ? validateDataListObj.area.name
                  : "",

              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };

          case 2:
            return {
              srNo: indexRow + 1,
              countryName:
                validateDataListObj.country !== null &&
                validateDataListObj.country.name !== null
                  ? validateDataListObj.country.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",

              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };

          case 3:
            return {
              srNo: indexRow + 1,
              regionName:
                validateDataListObj.region !== null &&
                validateDataListObj.region.name !== null
                  ? validateDataListObj.region.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              code:
                validateDataListObj.code !== null
                  ? validateDataListObj.code
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",
              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };

          case 4:
            return {
              srNo: indexRow + 1,
              stateName:
                validateDataListObj.state !== null &&
                validateDataListObj.state.name !== null
                  ? validateDataListObj.state.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",
              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };

          case 5:
            return {
              srNo: indexRow + 1,
              zoneName:
                validateDataListObj.zone !== null &&
                validateDataListObj.zone.name !== null
                  ? validateDataListObj.zone.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",
              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };
          case 6:
            return {
              srNo: indexRow + 1,
              districtName:
                validateDataListObj.district !== null &&
                validateDataListObj.district.name !== null
                  ? validateDataListObj.district.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",
              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };
          case 7:
            return {
              srNo: indexRow + 1,
              talukaName:
                validateDataListObj.taluka !== null &&
                validateDataListObj.taluka.name !== null
                  ? validateDataListObj.taluka.name
                  : "",
              name:
                validateDataListObj.name !== null
                  ? validateDataListObj.name
                  : "",
              shortName:
                validateDataListObj.shortName !== null
                  ? validateDataListObj.shortName
                  : "",
              sortOrder:
                validateDataListObj.flag == 0
                  ? validateDataListObj.sortOrder !== null
                    ? validateDataListObj.sortOrder
                    : ""
                  : validateDataListObj.sortOrde !== null
                  ? validateDataListObj.sortOrde
                  : "",
              errorMessage:
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
              errorFlag: validateDataListObj.flag,
            };

          default:
            return {
              "Sr. No": indexRow + 1,
              Name: validateDataListObj.name || "",
              "Short Name": validateDataListObj.shortName || "",
              "Sort Order": sortOrderNo,
              "Error Message":
                validateDataListObj.flag == 0
                  ? "-"
                  : validateDataListObj.errorMessage || "",
            };
        }
      }
    );
  };

  return (
    <>
      <Paper sx={{ p: 3, pt: 2, borderRadius: 2 }} elevation={0}>
        <BootstrapDialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          fullWidth
          maxWidth={columnTag == 7 || columnTag == 8 ? "xl" : "lg"}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            backgroundColor="#F0F0F0"
            fontFamily="'Montserrat', sans-serif"
            fontSize="23px"
            color="black"
          >
            {validationTableTitle}
          </BootstrapDialogTitle>

          <DialogContent dividers>
            <LandingScreenHeader
              screenTitle={""}
              showSearchBox={true}
              showTable={true}
              showFilter={false}
              showPdfDownload={false}
              showExcelDownload={false}
              onSearch={onSearchBox}
            />

            <StaticTableComponent
              title=""
              headers={getHeaders()}
              data={getTableData()}
              flag={1}
            />
          </DialogContent>

          <br />
          <DialogActions sx={{ justifyContent: "flex-end", padding: 2 }}>
            <Button
              size="medium"
              type="submit"
              variant="contained"
              name="Import Validated Only"
              color="primary"
              startIcon={<FileUploadIcon />}
              sx={{
                fontWeight: 600,
                padding: "5px 15px",
                border: "none",
                borderRadius: "6px",
                textTransform: "none",
                opacity: 0.6,
                color: "white",
                transition: "opacity 0.3s, transform 0.2s",
                boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                "&:hover": {
                  backgroundColor: "#57B9FF",
                  borderColor: "#1976d2",
                  color: "white",
                  opacity: 1,
                  transform: "translateY(-2px)",
                  boxShadow: "0 6px 10px rgba(0, 0, 0, 0.2)",
                },
              }}
              onClick={onImportValidatedData}
            >
              Import Validated Only
            </Button>
          </DialogActions>
        </BootstrapDialog>
      </Paper>
    </>
  );
};

const mapStateToProps = (state) => ({
  beatList: state.beat,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ValidatePopUpForGeographical);
